import React, { forwardRef, useState } from "react";

import useDatabase from "../Hooks/useDatabase";

import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";

import { IMaskInput } from "react-imask";
import Input from "@mui/material/Input";

import Grid from "@mui/material/Unstable_Grid2";

import Button from "@mui/material/Button";

const ValidationTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    backgroundColor: "#F8F8F8",
    borderRadius: "16px",
  },
  "& .MuiInputLabel-root": {
    top: "-5px",
  },
  "& .MuiInputBase-input": {
    position: "relative",
    backgroundColor: "#F8F8F8",
    fontSize: 16,
    width: "auto",
    padding: "10px",
    borderRadius: "16px",
  },
  "& input:valid + fieldset": {
    borderColor: "green",
    borderWidth: 2,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#F8F8F8",
    },
    "&:hover fieldset": {
      borderColor: "grey",
    },
  },
  "& .css-wgai2y-MuiFormLabel-asterisk": {
    display: "none",
  },
}));

const ValidationInput = styled(Input)(({ theme }) => ({
  "&.MuiInputBase-root": {
    borderRadius: "16px",
    border: "solid 1px #F8F8F8",
    backgroundColor: "#F8F8F8",
    padding: "5px",
  },
  // "&.MuiInputBase-root:hover:not(.Mui-disabled, .Mui-error):before": {
  //   borderBottom: "2px",
  //   borderColor: "grey",
  // },
  // "&.MuiInputBase-root:hover:not(.Mui-disabled, .Mui-error):after": {
  //   borderBottom: "2px",
  //   borderColor: "grey",
  // },
  "&.MuiInputBase-root:before": {
    height: "100%",
    border: "solid 0px grey",
    borderRadius: "16px",
  },
  "&.MuiInputBase-root:hover:not(.Mui-disabled, .Mui-error):before": {
    border: "solid 1px grey",
  },
  "& input:valid + :before": {
    borderColor: "green",
    borderWidth: 2,
  },
  "&.MuiInputBase-root:after": {
    display: "none",
  },
  "& .MuiInputBase-root": {
    "& fieldset": {
      borderColor: "#F8F8F8",
    },
  },
}));

const Telefono = forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask={"(#00) 000-0000"}
      definitions={{
        "#": /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
      placeholder="Numero de teléfono"
    />
  );
});

const FormConatct = () => {
  const [consulta, setConsulta] = useState({ consulta: "" });

  const [state, setState] = useState({
    nombre: "",
    correo: "",
    telefono: "",
    empresa: "",
    pais: "",
    ciudad: "",
    fecha: new Date(),
    estado: true,
  });

  useDatabase(consulta);

  const leerDato = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const enviar = (e) => {
    e.preventDefault();

    setConsulta({
      consulta: "agregarDocumento",
      collectionName: "mensajesPremios",
      state,
      url: "/",
    });

    document.getElementById("formulario").reset();
  };

  return (
    <section>
      <form id="formulario" onSubmit={enviar}>
        <Grid style={{ marginBottom: "10px" }} container spacing={2}>
          <Grid xs={12} md={6}>
            <p className="texto_form">
              Nombre <span>*</span>
            </p>
            <ValidationTextField
              onChange={leerDato}
              placeholder="Nombre"
              name="nombre"
              variant="outlined"
              fullWidth
              required
            />
          </Grid>
          <Grid xs={12} md={6}>
            <p className="texto_form">
              Email <span>*</span>
            </p>
            <ValidationTextField
              onChange={leerDato}
              placeholder="Correo electrónico"
              name="correo"
              variant="outlined"
              type={"email"}
              fullWidth
              required
            />
          </Grid>
          <Grid xs={12} md={6}>
            <p className="texto_form">
              Nombre de empresa o institución <span>*</span>
            </p>
            <ValidationTextField
              onChange={leerDato}
              placeholder="Nombre de empresa"
              name="empresa"
              variant="outlined"
              fullWidth
              required
            />
          </Grid>
          <Grid xs={12} md={6}>
            <p className="texto_form">
              Telefono <span>*</span>
            </p>
            <ValidationInput
              onChange={leerDato}
              name="telefono"
              value={state.telefono}
              inputComponent={Telefono}
              fullWidth
              required
            />
          </Grid>
          <Grid xs={12} md={6}>
            <p className="texto_form">
              País <span>*</span>
            </p>
            <ValidationTextField
              onChange={leerDato}
              placeholder="País"
              name="pais"
              variant="outlined"
              fullWidth
              required
            />
          </Grid>
          <Grid xs={12} md={6}>
            <p className="texto_form">
              Ciudad <span>*</span>
            </p>
            <ValidationTextField
              onChange={leerDato}
              placeholder="Ciudad"
              name="ciudad"
              variant="outlined"
              fullWidth
              required
            />
          </Grid>
        </Grid>
        <Button className="boton_formulario" type="submit" variant="contained">
          Enviar mensaje
        </Button>
      </form>
    </section>
  );
};

export default FormConatct;
